// RegEx
const youtubeRegex = /^(?:(?:https?:)?\/\/)?(?:(?:www|m)\.)?(?:(?:youtube\.com|youtu.be))(?:\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(?:\S+)?$/;
const vimeoRegex = /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;
const twitterRegex = /(?:http:\/\/)?(?:www\.)?twitter\.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[\w]*\/)*([\w]*)/;
const nearpodRegex = /(?:http:\/\/)?(?:www\.)?app\.nearpod\.com\/\?pin=(.*)/;
const flatIoRegex = /(?:http:|https:|)\/\/flat.io\/score\/(.*)/;
const padletRegex = /(.*\.)?padlet\.(com|org)/;
const codepenRegex = /^(?:http:\/\/|https:\/\/)?(?:www\.)?codepen\.io\/([A-Za-z0-9-]+)\/(?:pen|embed)\/([A-Za-z]+)$/;
const typeformRegex = /(http:\/\/|https:\/\/|)?(www\.)?.*typeform\.com.*/;
const googleformRegex = /(http:|https:)\/\/(docs.google.com(\/.*)?\/forms|goo.gl(\/.*)?\/forms)\/d\/e\/.*/;

// YouTube
export const isYoutubeUrl = (url: string) => youtubeRegex.test(url);
export const getYoutubeId = (url: string) => {
  const [, id] = url.match(youtubeRegex) || [];

  return id;
};
export const getEmbedYoutubeUrl = (url: string) =>
  `https://www.youtube.com/embed/${getYoutubeId(url)}`;

// Vimeo
export const isVimeoUrl = (url: string) => vimeoRegex.test(url);
export const getVimeoId = (url: string) => (url.match(vimeoRegex) || [])[4];
export const getEmbedVimeoUrl = (url: string) =>
  `https://player.vimeo.com/video/${getVimeoId(url)}`;

// Nearpod
export const isNearpodUrl = (url: string) => !!url.match(nearpodRegex);
export const getNearpodId = (url: string) => (url.match(nearpodRegex) || [])[4];
export const getEmbedNearpodUrl = (url: string) => url;

// Twitter
export const isTwitterUrl = (url: string) => twitterRegex.test(url);
export const getTwitterId = (url: string) => {
  const [, id] = url.match(twitterRegex) || [];

  return id;
};
export const getEmbedTwitterUrl = (url: string) =>
  `https://platform.twitter.com/embed/Tweet.html?dnt=false&embedId=twitter-widget-0&features=e30%3D&frame=false&hideCard=false&hideThread=false&id=${getTwitterId(
    url
  )}&lang=en&origin=about%3Asrcdoc&theme=light&widgetsVersion=2d233ae%3A1618352735472`;

// Flat
const isFlatIoUrl = (url: string) => !!url.match(flatIoRegex);
const getEmbedFlatIoUrl = (url: string) =>
  `${url.replace('/score', '/embed')}?layout=responsive`;

// Padlet
export const isPadletUrl = (url: string) => padletRegex.test(url);

// Codepen
export const isCodepenUrl = (url: string) => codepenRegex.test(url);
export const getEmbedCodepenUrl = (url: string) => {
  const match = url.match(codepenRegex);
  if (!match) return '';
  const [, author, penId] = match;
  return `https://codepen.io/${author}/embed/${penId}?height=650&theme-id=dark&default-tab=html,result`;
};
// Typeform
export const isTypeformUrl = (url: string) => typeformRegex.test(url);

// Google Form
export const isGoogleFormUrl = (url: string) => googleformRegex.test(url);
export const getEmbedGoogleFormUrl = (url: string) => {
  const match = url.match(googleformRegex);
  if (!match) return '';

  return `${url}?embedded=true`;
};

// Collapsible embedded
export const isCollapsibleEmbeddedUrl = (url: string) =>
  isTwitterUrl(url) ||
  isFlatIoUrl(url) ||
  isPadletUrl(url) ||
  isCodepenUrl(url) ||
  isTypeformUrl(url) ||
  isGoogleFormUrl(url);

export const getCollapsibleEmbeddedProps = (url: string): any => {
  if (isTwitterUrl(url)) {
    return {
      oEmbedApi: 'https://publish.twitter.com/oembed',
      oEmbedUrl: `https://twitter.com/aula_education/status/${getTwitterId(
        url
      )}`,
      src: getEmbedTwitterUrl(url),
      width: '100%',
    };
  }

  if (isPadletUrl(url)) {
    return {
      src: url,
      width: '100%',
      minHeight: 650,
    };
  }

  if (isFlatIoUrl(url)) {
    return {
      src: getEmbedFlatIoUrl(url),
      width: '90%',
      minHeight: 300,
    };
  }

  if (isCodepenUrl(url)) {
    return {
      src: getEmbedCodepenUrl(url),
      width: '100%',
      minHeight: 650,
    };
  }

  if (isTypeformUrl(url)) {
    return {
      src: url,
      width: '100%',
      minHeight: 584,
    };
  }

  if (isGoogleFormUrl(url)) {
    return {
      src: getEmbedGoogleFormUrl(url),
      width: '100%',
      minHeight: 650,
    };
  }

  return {};
};
